import React from 'react';

import MainContainer from '@/components/layout/MainContainer';

export const MobileSecurityLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => <MainContainer>{children}</MainContainer>;
